import {withNamespaces} from "react-i18next";
import React, {useEffect, useState} from "react";
import $ from "jquery";
import pic_create from "../../assets/images/mgsuite/Tabelle_24x24.png";
import pic_list from "../../assets/images/mgsuite/Tabelle_24x24.png";
import ReservierungsListe from "./ReservierungsListe";
import ReservierungEdit from "./ReservierungEdit";
import ReservierungsListeFilter from "./ReservierungsListeFilter";

const ReservationService = (props) => {
    const activeRights = JSON.parse(localStorage.getItem("rights"));

    const [selectedType, setSelectedType] = useState("liste");
    const [listFilterOptions, setListFilterOptions] = useState({
        department: null,
        from: null,
        till: null,
    });
    const [editBuchungId, setEditBuchungId] = useState();
    
    $(".einstellungen-container")
        .css("background-color", "unset")
        .css("color", "unset");
    $("#" + selectedType)
        .css("background-color", "#e9ecef")
        .css("color", "unset");

    function editBuchung(id) {
        setEditBuchungId(id);
        setSelectedType('editBuchung');
    }
    
    function mainView() {
        function renderView() {
            switch (selectedType) {
                case "editBuchung":
                    return (<ReservierungEdit onChange={() => { setSelectedType("liste"); setEditBuchungId(null); }} editId={editBuchungId}>{" "}</ReservierungEdit>);
                case "liste":
                    return (<ReservierungsListe translation={props.t} filterOptions={listFilterOptions} onEdit={(id) => editBuchung(id)}>{" "}</ReservierungsListe>);
            }
        }

        return (
            <div className="left-container-se settings-left">
                {renderView()}
            </div>
        );
    }

    return (
        <div className="pagewrapper-2">
            {mainView()}

            <div className="right-container-se" id="selection">
                <div className="content-name">{props.t("allgemein.auswahl")}</div>
                <div className="content">
                    <div className="content-group">
                        {activeRights.find((item) => item.includes("ReservationService.Create")) && (
                            <div className="einstellungen-container" onClick={() => setSelectedType("editBuchung")}>
                                <img src={pic_create} alt={props.t("reservationService.naviLinkCreateReservation")} className="einstellungen-img"/>
                                {props.t("reservationService.naviLinkCreateReservation")}
                            </div>)
                        }

                        {activeRights.find((item) => item.includes("ReservationService.Get")) && (
                            <div className="einstellungen-container" onClick={() => setSelectedType("liste")}>
                                <img src={pic_list} alt={props.t("reservationService.naviLinkList")} className="einstellungen-img"/>
                                {props.t("reservationService.naviLinkList")}
                            </div>)
                        }
                    </div>

                    {selectedType === "liste" && <ReservierungsListeFilter translation={props.t}
                                                             departmentChanged={(d) => {
                                                                 console.log('Deparment changed', d);
                                                                 setListFilterOptions({...listFilterOptions, department: d});
                                                             }}
                                                             timeSpanSendButtonClicked={(from, till)=>{
                                                                 console.log('DateTime-SendButton Clicked: %o - %o', from, till);
                                                                 setListFilterOptions({...listFilterOptions, from: from, till: till});
                                                             }}
                    />}
                </div>
            </div>

        </div>
    );
};

export default withNamespaces()(ReservationService);
